import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSettingSlide: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.905 9.14V6.1h4.57V4.57h-4.57V1.52h-1.52v7.62zm0 21.34v-3.05h4.57V25.9h-4.57v-3.04h-1.52v7.62zm4.57-15.24H9.145v-3.05h-1.52v-1.52h-1.53v1.52h-1.52v3.05h-3.05v1.52h3.05v3.05h1.52v1.52h1.53v-1.52h1.52v-3.05h21.33zm-7.62 15.24h1.53V32h-1.53Zm0-9.15h1.53v1.53h-1.53Zm0-12.19h1.53v1.53h-1.53Zm0-9.14h1.53v1.52h-1.53Zm0 22.86h-1.52v3.04H1.525v1.53h19.81v3.05h1.52zm-1.52-18.29H1.525V6.1h19.81v3.04h1.52V1.52h-1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSettingSlide
